<section class="is-flex gap-16">
  <app-radio-button-group size="small">
    <app-radio-button-item
      (click)="selectPinType(PinType.TEMPERATURE)"
      ga-event="controls-temperature"
      [selected]="selectedType() === PinType.TEMPERATURE"
    >
      <app-radio-button-icon icon="temperature" />
    </app-radio-button-item>
    <app-radio-button-item
      (click)="selectPinType(PinType.RAIN)"
      ga-event="controls-rain"
      [selected]="selectedType() === PinType.RAIN"
    >
      <app-radio-button-icon icon="rain" />
    </app-radio-button-item>
    <app-radio-button-item
      (click)="selectPinType(PinType.WIND)"
      ga-event="controls-wind"
      [selected]="selectedType() === PinType.WIND"
    >
      <app-radio-button-icon icon="wind" />
    </app-radio-button-item>
  </app-radio-button-group>
</section>
